import React, { type DetailedHTMLProps, type InputHTMLAttributes } from 'react';
import { type FieldError } from 'react-hook-form';
import styled, { css } from 'styled-components';

import { RadioButtonInput } from './RadioButtonInput';

type RadioButtonOptionType = { id: boolean | string; label: string };

export interface BaseRadioGroupInputProps
	extends Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'onChange'> {
	disabled?: boolean;
	error?: FieldError;
	isChip?: boolean;
	onChange: (value: string) => void;
	onChangeSelected?: (option?: string) => void;
	options: Array<RadioButtonOptionType>;
	pressableLabels?: boolean;
	row?: boolean;
	testID: string;
	title?: string;
	value: string;
}

export const BaseRadioGroupInput = ({
	disabled = false,
	isChip = false,
	onChange,
	onChangeSelected,
	options,
	pressableLabels = true,
	row = false,
	testID,
	title,
	value,
	...props
}: BaseRadioGroupInputProps) => {
	return (
		<div data-testid={testID} {...props}>
			{title && <S.Title>{title}</S.Title>}
			<S.RadioGroupOptionsDiv row={row}>
				{options.map((item: RadioButtonOptionType) => (
					<S.RadioGroupOptionLineView key={item.id.toString()}>
						<RadioButtonInput
							checked={value === item.id}
							disabled={disabled}
							isChip={isChip}
							item={item}
							pressableLabels={pressableLabels}
							onPress={() => {
								onChangeSelected?.(item.id.toString());
								onChange?.(item.id.toString());
							}}
						/>
					</S.RadioGroupOptionLineView>
				))}
			</S.RadioGroupOptionsDiv>
		</div>
	);
};
namespace S {
	export const Title = styled.label`
		${({ theme }) => theme.fonts.text.text1};
		margin-bottom: ${({ theme }) => theme.spacings.small};
		display: block;
	`;

	export const RadioGroupOptionsDiv = styled.div<{ row?: boolean }>`
		${({ row }) => row && 'display: flex'};
		gap: ${({ theme }) => theme.spacings.xxsmall};
		flex-wrap: wrap;
	`;

	export const RadioGroupOptionLineView = styled.div<{ $isChip?: boolean }>`
		${({ $isChip }) =>
			$isChip &&
			css`
				margin-bottom: 18px;
				height: 18px;
			`};
	`;
}
